import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { trackLogin } from "../../controller/UserC";
import moment from 'moment';
export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [user, setUser] = useState([])

  const getUserFunc = async () => {
    try {
      setUser([])
      const response = await trackLogin(cookies, props.userId)
      setUser(response)
    } catch (e) {
      alert('Người dùng ko tồn tại, không thể lấy thông tin tài khoản')
    }
  }

  useEffect(() => {
    if (props.show && props.userId) {
      getUserFunc()
    }
  }, [props.show, props.userId])

  console.log(user)

  return (
    <Modal
      fullscreen
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Phiên đăng nhập của {props.userId}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table bordered style={{ textAlign: 'center', verticalAlign: 'middle' }}>
          <thead style={{ backgroundColor: 'gray', color: 'white' }}>
            <tr>
              <th>STT</th>
              <th>Nền tảng</th>
              <th>Tên thiết bị</th>
              <th>Model</th>
              <th>Hệ điều hành</th>
              <th>Phiên bản APP</th>
              <th>Thiết bị Thật / Ảo</th>
              <th>Lần cuối truy cập</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {user.length > 0 && user.map((item, index) => {
              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.endPointId}</td>
                  <td>{item.SmartPhone ? item.SmartPhone.name : ''}</td>
                  <td>
                    {item.SmartPhone ? item.SmartPhone.model : ''}<br />
                    {item.SmartPhone ? item.SmartPhone.modelName : ''}
                  </td>
                  <td>
                    {item.SmartPhone ? item.SmartPhone.OS : ''}<br />
                    {item.SmartPhone ? item.SmartPhone.OSVersion : ''}
                  </td>
                  <td>{item.SmartPhone ? item.SmartPhone.appVersion : ''}</td>
                  <td>{item.SmartPhone ? item.SmartPhone.isPhysicalDevice ? 'Thật' : 'Ảo' : ''}</td>
                  <td>{item.lastUsedAt ? moment(item.lastUsedAt || '').format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                  <td>
                    <Button variant="danger" onClick={() => {
                      props.onHide()
                    }}>Xóa</Button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button variant="success" onClick={syncAmount}>Xem lịch sử tài khoản</Button> */}
        <Button variant="info" onClick={props.onHide}>Ngưng nhận thông báo APP</Button>
        <Button variant="danger" onClick={props.onHide}>Khóa người dùng</Button>
        <Button variant="primary" onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
